import type { IAddress } from '@/types';
import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IRecipientInfoProps extends IAddress {
  email?: string;
  fullname: string;
  phone?: string;
}

export const RecipientInfo: React.FC<IRecipientInfoProps> = ({
  city,
  countryCode,
  email,
  fullname,
  phone,
  streetAddress,
  zipCode,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Box>
      <Text textTransform="uppercase">{t('QUOTE_DETAILS.RECIPIENT')}</Text>
      <Text fontSize="h4" fontWeight="bold" textTransform="capitalize">
        {fullname}
      </Text>
      <Text>
        {streetAddress}
        <br /> {zipCode} {city} {countryCode}
      </Text>
      {(phone || email) && (
        <Text mt={4}>
          {phone && (
            <Text>
              {t('QUOTE_DETAILS.PHONE_PREFIX')} {phone}
            </Text>
          )}
          {email && (
            <Text>
              {t('QUOTE_DETAILS.EMAIL_PREFIX')} {email}
            </Text>
          )}
        </Text>
      )}
    </Box>
  );
};
